import React from "react";
import ContactUs from "./ContactUs";

import "./Analytics.css";
import dataAnalyticsPDF from "../assets/Data Analytics - Codex Future Syllabus.pdf";

const Analytics = () => {
  return (
    <>
     

      {/* ✅ Data Analytics Course Section */}
      <section className="analytics-section">
        <div className="analytics-container">
          <h1 className="analytics-title">
            100% Job Assistance Data Analytics Course
          </h1>
          <p className="analytics-subtitle">
            Online & Classroom Available*
          </p>

          <div className="analytics-rating">
            <span>⭐ 4.8 Reviews</span>
          </div>

          <div className="analytics-duration">
            <p><strong>Duration:</strong> 3 to 4 Months</p>
            <p><strong>10+ Guaranteed Interviews</strong></p>
          </div>

          <div className="analytics-description">
            <p>
              Welcome to <strong>Codex Future</strong>, where we provide training that upskills you.
              Our industry-experienced mentors will help you embrace future challenges and obstacles
              with confidence, ensuring that your career continues to grow without barriers.
            </p>
            <button
  className="analytics-btn"
  onClick={() => window.open(dataAnalyticsPDF, "_blank")}
>
  📘 Download Syllabus
</button>
          </div>

          <h2 className="analytics-heading">
            Data Analytics Course: Master the Art of Data-Driven Decision Making
          </h2>
          <p className="analytics-text">
            Unlock the power of data with our comprehensive Data Analytics Course. Designed for
            professionals and enthusiasts alike, this 3-month intensive program will equip you with
            essential skills in statistics, data handling, and cutting-edge analytics tools. Whether
            you're aiming to boost your career or harness data to drive business insights, this
            course provides a practical and hands-on approach to mastering data analytics.
          </p>

          <h2 className="analytics-heading">Course Highlights:</h2>
          <ul className="analytics-list">
            <li><strong>Duration:</strong> 3 Months (Offline)</li>
            <li><strong>Format:</strong> Interactive Lectures, Hands-On Labs, Real-World Projects</li>
            <li><strong>Certification:</strong> Course Completion Certificate</li>
          </ul>

          <h2 className="analytics-heading">Why Choose This Course?</h2>
          <ul className="analytics-list">
            <li>
              <strong>Hands-On Learning:</strong> Practical exercises and real-world projects to solidify your understanding.
            </li>
            <li>
              <strong>Expert Instructors:</strong> Learn from experienced professionals with industry insights.
            </li>
            <li>
              <strong>Career-Ready Skills:</strong> Gain competencies that are highly valued in today's data-driven job market.
            </li>
            <li>
              <strong>Certification:</strong> Receive a certificate upon successful completion, showcasing your new skills to potential employers.
            </li>
          </ul>
        </div>
      </section>

      {/* ✅ ContactUs Section */}
      <ContactUs />

     
    </>
  );
};

export default Analytics;
